import { render, staticRenderFns } from "./summary.vue?vue&type=template&id=c2f9bd6e&scoped=true&"
import script from "./summary.vue?vue&type=script&lang=js&"
export * from "./summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f9bd6e",
  null
  
)

export default component.exports